var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"tab"},_vm._l((_vm.menuItems),function(item){return _c('router-link',{key:item.path,staticClass:"tab-item",attrs:{"active-class":"active","to":{
        path: item.path,
        query: { name: _vm.name }
      }}},[_vm._v(" "+_vm._s(item.title))])}),1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }